/**
 * @desc 保存供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoSaveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
